import React from "react";
import Download from "molecule/Download";
import data from "./data";

export default () => <Download {...data.caregiver} reverse />;
